<script>
  import { onDestroy, onMount } from "svelte";
  import { teamStore } from "../../../../api-stores/license-store";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import ConfirmChangesModal from "../ConfirmChangesModal/ConfirmChangesModal.svelte";
  import { getAdminPanelContext } from "../context";

  const { modifiedTeamStore } = getAdminPanelContext();

  const process = (x) =>
    Object.fromEntries(
      (x?.users || [])
        .toSorted((a, b) => a.userId.localeCompare(b.userId))
        .map((u) => [u.userId, (u.licenses || []).toSorted()])
    );

  let next = $derived(process($teamStore));
  let current = $derived(process($modifiedTeamStore));
  let disabled = $derived(JSON.stringify(current) === JSON.stringify(next));
  let cls = $derived(disabled ? "disabled" : "");

  const onbeforeunload = (e) => {
    if (!disabled) {
      e.preventDefault();
    }
    return !disabled;
  };
  onMount(() => {
    window.addEventListener("beforeunload", onbeforeunload);
  });
  onDestroy(() => {
    window.removeEventListener("beforeunload", onbeforeunload);
  });

  let show = $state(false);
  const onclick = () => {
    show = true;
  };
</script>

<Button
  class={cls}
  kind="primary"
  leadingIcon="fa-regular fa-save"
  {disabled}
  {onclick}>Save</Button
>

<ConfirmChangesModal bind:show />
